import type { SVGProps } from 'react';

export function DoveIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21 4.8a.6.6 0 0 1 .48.96L20.4 7.2v6.6c0 2.981-2.419 5.4-5.4 5.4h-4.2l-1.736 1.736c-.39.39-.994.465-1.466.18l-3.642-2.182a.902.902 0 0 1 .128-1.609L8.4 15.6c-5.107-1.534-5.719-6.832-5.175-9.611.135-.668.874-.911 1.474-.581L14.4 10.8v-3a3 3 0 0 1 3-3zm-3.6 2.1c-.499 0-.9.401-.9.9s.401.9.9.9.9-.401.9-.9-.401-.9-.9-.9M9.244 2.04c.465-.514 1.249-.334 1.594.266l2.115 3.687a4.8 4.8 0 0 0-.353 1.743L7.579 4.95a8.1 8.1 0 0 1 1.665-2.91" />
    </svg>
  );
}
